<script>
  import { Gradients } from "../facet-value-label";
</script>

<Gradients />
